import { Box, HStack, IconButton, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useNotifications } from "@/hooks/useNotifications";
import { useMe } from "@/hooks/useAuth";
import { useUnreadChangelog } from "@/hooks/useChangelog";

export default function NotificationBell() {
  const { data: me } = useMe();
  const { data } = useNotifications();
  // Changelog bell-dot — small purple indicator at top-left to avoid
  // colliding with the red unread-notification count at top-right.
  // Gated on me so the unauthenticated /login bounce doesn't poll.
  const { data: changelog } = useUnreadChangelog(Boolean(me));
  const count = data?.unreadCount ?? 0;
  const changelogUnread = (changelog?.count ?? 0) > 0;
  return (
    <HStack>
      <IconButton asChild variant="ghost" size="sm" aria-label="Notifications">
        <Link to="/notifications">
          <Box position="relative">
            <Text fontSize="lg">&#128276;</Text>
            {count > 0 ? (
              <Box
                position="absolute"
                top="-2px"
                right="-6px"
                minW="16px"
                h="16px"
                px={1}
                borderRadius="full"
                bg="red.500"
                color="white"
                fontSize="10px"
                fontWeight="bold"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                {count > 9 ? "9+" : count}
              </Box>
            ) : null}
            {changelogUnread ? (
              <Box
                position="absolute"
                top="-2px"
                left="-4px"
                w="8px"
                h="8px"
                borderRadius="full"
                bg="purple.500"
                title="What's new"
              />
            ) : null}
          </Box>
        </Link>
      </IconButton>
    </HStack>
  );
}
